var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGanttMobilecolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 340 378",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    width: 340,
    height: 378,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 378,
    fill: "#fff",
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M281.727 252h25.228a5.94 5.94 0 010 11.879h-25.228V252z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M133.97 257.94a5.94 5.94 0 015.939-5.94h36.002v11.879h-36.002a5.939 5.939 0 01-5.939-5.939z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M175.911 252h105.815v11.879H175.911z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.212,
    cy: 257.94,
    r: 3.712,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M263.151 209h43.803a5.94 5.94 0 110 11.879h-43.803V209z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M133.97 214.94a5.94 5.94 0 015.939-5.94h71.273v11.879h-71.273a5.939 5.939 0 01-5.939-5.939z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M211.182 209h51.97v11.879h-51.97z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.212,
    cy: 214.94,
    r: 3.712,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M247.195 296h59.76a5.94 5.94 0 010 11.879h-59.76V296z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M133.97 301.94a5.939 5.939 0 015.939-5.939h63.953v11.879h-63.953a5.94 5.94 0 01-5.939-5.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M175.905 296h71.29v11.879h-71.29z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.212,
    cy: 301.94,
    r: 3.712,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M281.442 339h25.512a5.94 5.94 0 110 11.879h-25.512V339z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M133.97 344.94a5.94 5.94 0 015.939-5.94h101.695v11.879H139.909a5.939 5.939 0 01-5.939-5.939z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M175.905 339h105.537v11.879H175.905z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.212,
    cy: 344.94,
    r: 3.712,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M87 192h256.333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M87 279.2h256.333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M87 235.6h256.333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M87 322.8h256.333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M87 366.4h256.333"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQwIiBoZWlnaHQ9IjM3OCIgdmlld0JveD0iMCAwIDM0MCAzNzgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjM0MCIgaGVpZ2h0PSIzNzgiPgo8cmVjdCB3aWR0aD0iMzQwIiBoZWlnaHQ9IjM3OCIgcng9IjIwIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHBhdGggb3BhY2l0eT0iMC4yIiBkPSJNMjgxLjcyNyAyNTJIMzA2Ljk1NUMzMTAuMjM1IDI1MiAzMTIuODk0IDI1NC42NTkgMzEyLjg5NCAyNTcuOTM5VjI1Ny45MzlDMzEyLjg5NCAyNjEuMjIgMzEwLjIzNSAyNjMuODc5IDMwNi45NTUgMjYzLjg3OUgyODEuNzI3VjI1MloiIGZpbGw9IiNERjRCODUiLz4KPHBhdGggZD0iTTEzMy45NyAyNTcuOTRDMTMzLjk3IDI1NC42NiAxMzYuNjI5IDI1MiAxMzkuOTA5IDI1MkgxNzUuOTExVjI2My44NzlIMTM5LjkwOUMxMzYuNjI5IDI2My44NzkgMTMzLjk3IDI2MS4yMiAxMzMuOTcgMjU3Ljk0VjI1Ny45NFoiIGZpbGw9IiNERjRCODUiLz4KPHJlY3Qgb3BhY2l0eT0iMC41IiB4PSIxNzUuOTExIiB5PSIyNTIiIHdpZHRoPSIxMDUuODE1IiBoZWlnaHQ9IjExLjg3ODgiIGZpbGw9IiNERjRCODUiLz4KPGNpcmNsZSBjeD0iMTEwLjIxMiIgY3k9IjI1Ny45NCIgcj0iMy43MTIxMiIgZmlsbD0iIzJDMjY2NCIvPgo8cGF0aCBvcGFjaXR5PSIwLjIiIGQ9Ik0yNjMuMTUxIDIwOUgzMDYuOTU0QzMxMC4yMzUgMjA5IDMxMi44OTQgMjExLjY1OSAzMTIuODk0IDIxNC45MzlWMjE0LjkzOUMzMTIuODk0IDIxOC4yMiAzMTAuMjM1IDIyMC44NzkgMzA2Ljk1NCAyMjAuODc5SDI2My4xNTFWMjA5WiIgZmlsbD0iI0RGNEI4NSIvPgo8cGF0aCBkPSJNMTMzLjk3IDIxNC45NEMxMzMuOTcgMjExLjY2IDEzNi42MjkgMjA5IDEzOS45MDkgMjA5SDIxMS4xODJWMjIwLjg3OUgxMzkuOTA5QzEzNi42MjkgMjIwLjg3OSAxMzMuOTcgMjE4LjIyIDEzMy45NyAyMTQuOTRWMjE0Ljk0WiIgZmlsbD0iI0RGNEI4NSIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjIxMS4xODIiIHk9IjIwOSIgd2lkdGg9IjUxLjk2OTciIGhlaWdodD0iMTEuODc4OCIgZmlsbD0iI0RGNEI4NSIvPgo8Y2lyY2xlIGN4PSIxMTAuMjEyIiBjeT0iMjE0Ljk0IiByPSIzLjcxMjEyIiBmaWxsPSIjMkMyNjY0Ii8+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZD0iTTI0Ny4xOTUgMjk2SDMwNi45NTVDMzEwLjIzNSAyOTYgMzEyLjg5NCAyOTguNjU5IDMxMi44OTQgMzAxLjkzOVYzMDEuOTM5QzMxMi44OTQgMzA1LjIyIDMxMC4yMzUgMzA3Ljg3OSAzMDYuOTU1IDMwNy44NzlIMjQ3LjE5NVYyOTZaIiBmaWxsPSIjREY0Qjg1Ii8+CjxwYXRoIGQ9Ik0xMzMuOTcgMzAxLjk0QzEzMy45NyAyOTguNjYgMTM2LjYyOSAyOTYuMDAxIDEzOS45MDkgMjk2LjAwMUgyMDMuODYyVjMwNy44OEgxMzkuOTA5QzEzNi42MjkgMzA3Ljg4IDEzMy45NyAzMDUuMjIxIDEzMy45NyAzMDEuOTRWMzAxLjk0WiIgZmlsbD0iI0RGNEI4NSIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjE3NS45MDUiIHk9IjI5NiIgd2lkdGg9IjcxLjI5IiBoZWlnaHQ9IjExLjg3ODgiIGZpbGw9IiNERjRCODUiLz4KPGNpcmNsZSBjeD0iMTEwLjIxMiIgY3k9IjMwMS45NCIgcj0iMy43MTIxMiIgZmlsbD0iIzJDMjY2NCIvPgo8cGF0aCBvcGFjaXR5PSIwLjIiIGQ9Ik0yODEuNDQyIDMzOUgzMDYuOTU0QzMxMC4yMzUgMzM5IDMxMi44OTQgMzQxLjY1OSAzMTIuODk0IDM0NC45MzlWMzQ0LjkzOUMzMTIuODk0IDM0OC4yMiAzMTAuMjM1IDM1MC44NzkgMzA2Ljk1NCAzNTAuODc5SDI4MS40NDJWMzM5WiIgZmlsbD0iI0RGNEI4NSIvPgo8cGF0aCBkPSJNMTMzLjk3IDM0NC45NEMxMzMuOTcgMzQxLjY2IDEzNi42MjkgMzM5IDEzOS45MDkgMzM5SDI0MS42MDRWMzUwLjg3OUgxMzkuOTA5QzEzNi42MjkgMzUwLjg3OSAxMzMuOTcgMzQ4LjIyIDEzMy45NyAzNDQuOTRWMzQ0Ljk0WiIgZmlsbD0iI0RGNEI4NSIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjE3NS45MDUiIHk9IjMzOSIgd2lkdGg9IjEwNS41MzciIGhlaWdodD0iMTEuODc4OCIgZmlsbD0iI0RGNEI4NSIvPgo8Y2lyY2xlIGN4PSIxMTAuMjEyIiBjeT0iMzQ0Ljk0IiByPSIzLjcxMjEyIiBmaWxsPSIjMkMyNjY0Ii8+CjxwYXRoIGQ9Ik04NyAxOTJMMzQzLjMzMyAxOTIiIHN0cm9rZT0iI0RBREFEQSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPHBhdGggZD0iTTg3IDI3OS4yTDM0My4zMzMgMjc5LjIiIHN0cm9rZT0iI0RBREFEQSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPHBhdGggZD0iTTg3IDIzNS42TDM0My4zMzMgMjM1LjYiIHN0cm9rZT0iI0RBREFEQSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPHBhdGggZD0iTTg3IDMyMi44TDM0My4zMzMgMzIyLjgiIHN0cm9rZT0iI0RBREFEQSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPHBhdGggZD0iTTg3IDM2Ni40TDM0My4zMzMgMzY2LjQiIHN0cm9rZT0iI0RBREFEQSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9nPgo8L3N2Zz4K";
export { SvgGanttMobilecolors as ReactComponent };